import request from '@/utils/request'

/** 拓客记录分页列表 */
export function getTkjlbList(data) {
  return request({
    url: '/api/Extend/LqTkjlb',
    method: 'get',
    data
  })
}

/** 新建拓客记录 */
export function createTkjlb(data) {
  return request({
    url: '/api/Extend/LqTkjlb',
    method: 'post',
    data
  })
}

/** 拓客统计（今日潜客数等） */
export function getTkStatistics(data) {
  return request({
    url: '/api/Extend/LqTkjlb/get-tk-statistics',
    method: 'post',
    data
  })
}
